import PersonalInformationOverride from 'Overrides/OnboardingStep/PersonalInformationOverride';
import OnboardingWelcomeOverride from 'Overrides/OnboardingStep/OnboardingWelcomeOverride';
import QualitativeQuestionOverride from './QualitativeQuestionOverride';
import DetailListOverride from './DetailListOverride';
import FamilyMemberDetailOverride from './FamilyMemberDetailOverride';
import AccountSetupOverride from './AccountSetupOverride';

module.exports = {
  DetailListOverride,
  QualitativeQuestionOverride,
  PersonalInformationOverride,
  FamilyMemberDetailOverride,
  OnboardingWelcomeOverride,
  AccountSetupOverride,
};
